// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../common/input';

type CamposTotaisProps = {
  component : React.ComponentType<*>,
}

export default function CamposTotais({ component } : CamposTotaisProps) {
  const SelecaoTodos = component || SelecaoTodosNfe,
        tipoNfe      = SelecaoTodos === SelecaoTodosNfe;

  return (
      <FormSection name="dadosTotais">
        <SelecaoTodos nomes={ ['dadosTotais'] } titulo="Dados dos Totais"/>

        <div className="grupo-checkbox">
          <Input name="totalBcIcms" label="Total Base Calculo do ICMS" checkbox/>
          <Input name="totalIcms" label="Total do ICMS" checkbox/>
          <Input name="totalIcmsDeson" label="Total do ICMS Desonerado" checkbox/>
          { tipoNfe &&
              <>
                <Input name="totalIcmsFcpUfDest" label="Total do ICMS relativo ao FCP da UF Destino" checkbox/>
                <Input name="totalIcmsInterUfDest" label="Total do ICMS Interestadual para a UF Destino" checkbox/>
                <Input name="totalIcmsInterUfRemet" label="Total do ICMS Interestadual para a UF Remetente" checkbox/>
              </>
          }
          <Input name="totalFcp" label="Total do FCP" checkbox/>
          <Input name="totalBcIcmsSt" label="Total Base Calculo do ICMS ST" checkbox/>
          <Input name="totalIcmsSt" label="Total do ICMS ST" checkbox/>
          <Input name="totalFcpRetidoSt" label="Total do FCP retido por ST" checkbox/>
          <Input name="totalFcpRetidoAntSt" label="Total do FCP retido anteriormente por ST" checkbox/>
          <Input name="totalProd" label="Total dos Produtos e Serviços" checkbox/>
          <Input name="totalFrete" label="Total do Frete" checkbox/>
          <Input name="totalSeguro" label="Total do Seguro" checkbox/>
          <Input name="totalDesconto" label="Total do Desconto" checkbox/>
          { tipoNfe &&
              <>
                <Input name="totalImpostoImportacao" label="Total do Imposto Importação (II)" checkbox/>
                <Input name="totalIpi" label="Total do IPI" checkbox/>
                <Input name="totalIpiDevolvido" label="Total do IPI Devolvido" checkbox/>
              </>
          }
          <Input name="totalPis" label="Total do PIS" checkbox/>
          <Input name="totalCofins" label="Total da COFINS" checkbox/>
          <Input name="totalOutras" label="Total Outras Despesas" checkbox/>
          <Input name="totalValor" label={tipoNfe ? 'Total da NF-e' : 'Total da NFC-e'} checkbox/>
          <Input name="totalTributos" label="Total Aprox. Tributos" checkbox/>
          { tipoNfe &&
            <>
              <Input name="impostoSeletivo" label="Imposto Seletivo (IS)" checkbox/>
              <Input name="bcIbsCbs" label="Base de Cálculo IBS e CBS" checkbox/>
              <Input name="ibsUfDiferimento" label="IBS da UF Diferimento" checkbox/>
              <Input name="ibsUfDevolucao" label="IBS da UF Devolução" checkbox/>
              <Input name="totalIbsUf" label="Total IBS da UF" checkbox/>
              <Input name="ibsMunDiferimento" label="IBS do Município Diferimento" checkbox/>
              <Input name="ibsMunDevolucao" label="IBS do Município Devolução" checkbox/>
              <Input name="totalIbsMun" label="Total IBS do Município" checkbox/>
              <Input name="totalIbs" label="Total do IBS" checkbox/>
              <Input name="creditoPresumidoIbs" label="Crédito Presumido IBS" checkbox/>
              <Input name="creditoPresumidoIbsCondSusp" label="Crédito Presumido IBS em Cond. Suspensiva" checkbox/>
              <Input name="cbsDiferimento" label="CBS Diferimento" checkbox/>
              <Input name="cbsDevolucaoTrib" label="CBS Devolução Tributos" checkbox/>
              <Input name="totalCbs" label="Total da CBS" checkbox/>
              <Input name="creditoPresumidoCbs" label="Crédito Presumido CBS" checkbox/>
              <Input name="creditoPresumidoCbsCondSusp" label="Crédito Presumido CBS em Cond. Suspensiva" checkbox/>
              <Input name="ibsMono" label="IBS Monofásico" checkbox/>
              <Input name="cbsMono" label="CBS Monofásica" checkbox/>
              <Input name="ibsMonoSujRet" label="IBS Monofásico Sujeito a Retenção" checkbox/>
              <Input name="cbsMonoSujRet" label="CBS Monofásica Sujeita a Retenção" checkbox/>
              <Input name="ibsMonoRetidoAnt" label="IBS Monofásico Retido Anteriormente" checkbox/>
              <Input name="cbsMonoRetidoAnt" label="CBS Monofásica Retida Anteriormente" checkbox/>
              <Input name="ibsEstornado" label="IBS Estornado" checkbox/>
              <Input name="cbsEstornada" label="CBS Estornada" checkbox/>
              <Input name="nfeIbsCbsIs" label="NFe com IBS/CBS/IS" checkbox/>
            </>
          }
        </div>
      </FormSection>
  );
}
